import {
	KAddressFormBox,
	KForm,
	KTextField
} from "kinnect-general";

export default KForm.extend( {
	name: "LocationForm",

	props: {
		location: Object,

		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "locations" } ]
		}
	},

	data: () => ( {
		formFields: {
			address: null,
			city: null,
			lat: null,
			lng: null,
			name: null,
			state: null,
			zip: null
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.location );
		},

		formUrl() {
			return this.editing
				? `locations/${this.location.id}`
				: "locations";
		}
	},

	watch: {
		location: {
			handler( location ) {
				if ( location ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( location.hasOwnProperty( key ) ) {
							this.formFields[key] = location[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				label="Location Name*"
				prependIcon="store"
				required
				vModel={this.formFields.name}
				validationName="name"
				validationRules="required"
			></KTextField>

			<KAddressFormBox
				address={this.formFields.address}
				city={this.formFields.city}
				class="mb-4 ml-blank-icon"
				lat={this.formFields.lat}
				lng={this.formFields.lng}
				on={{
					"update:address": val => this.formFields.address = val,
					"update:city": val => this.formFields.city = val,
					"update:lat": val => this.formFields.lat = val,
					"update:lng": val => this.formFields.lng = val,
					"update:state": val => this.formFields.state = val,
					"update:zip": val => this.formFields.zip = val
				}}
				required
				state={this.formFields.state}
				zip={this.formFields.zip}
			></KAddressFormBox>
		</KForm>;
	}
} );
